import type { ApiEndpointBuilder } from "../apiEndpointHelpers";
import { optionalQueryParams } from "../apiEndpointHelpers";

/** Published app-help metadata; media URLs are deliberately outside this contract. */
export interface AdminV2MessagingTemplateHelpArticle {
  kind: "app-help-video";
  slug: string;
  title: string;
  summary: string | null;
  url: string;
}

export interface AdminV2MessagingTemplateHelpArticlesResponse {
  articles: AdminV2MessagingTemplateHelpArticle[];
  pagination: { limit: number; offset: number; hasMore: boolean };
}

export interface AdminV2MessagingTemplateHelpArticlesQuery {
  /** Cache partition only; the server authorises the actual caller. */
  ownerKey?: string;
  q?: string;
  limit?: number;
  offset?: number;
}

/** Uses the existing API slice, authentication and permission error handling. */
export const buildAdminV2MessagingTemplateHelpEndpoints = (
  builder: ApiEndpointBuilder,
) => ({
  getAdminV2MessagingTemplateHelpArticles: builder.query<
    AdminV2MessagingTemplateHelpArticlesResponse,
    AdminV2MessagingTemplateHelpArticlesQuery | void
  >({
    query: (args) => ({
      url: "/admin/v2/messaging/templates/help-articles",
      params: optionalQueryParams(
        args
          ? { q: args.q, limit: args.limit, offset: args.offset }
          : undefined,
      ),
    }),
    keepUnusedDataFor: 20,
  }),
});
